module.exports = __webpack_public_path__ + "static/media/PaidSocial_Ad04-Image.d1c5edfc.jpg";